import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBtZWV0aW5nfGVufDB8fHx8MTc4NTg0MTIyNHww&ixlib=rb-4.1.0&q=85";

const POINTS = [
  "Officially registered in Dubai, UAE",
  "Headquartered in Business Bay, Dubai",
  "Transparent, outcome-driven engagements",
  "Local knowledge with a global network",
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" ref={ref} className="px-6 md:px-12 lg:px-24 py-24 md:py-32 lg:py-40" data-testid="about-section">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-quantum-gold mb-6">Who we are</p>
          <h2 className="font-serif-q text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-light text-quantum-text mb-8">
            Qauntum International
          </h2>
          <p className="text-lg text-quantum-muted leading-relaxed mb-6">
            We are a Dubai-registered services company bringing together
            the disciplines businesses and individuals need to thrive in global markets. From building brands
            and driving demand to
            arranging IT projects and hospitality, we act as a single trusted partner.
          </p>
          <p className="text-lg text-quantum-muted leading-relaxed mb-10">
            Our promise is simple: world-class execution, delivered with the discretion and
            precision our region is known for.
          </p>
          <ul className="grid sm:grid-cols-2 gap-4">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-1 grid place-items-center h-5 w-5 rounded-full bg-quantum-gold/15 text-quantum-gold shrink-0">
                  <Check size={12} />
                </span>
                <span className="text-quantum-text text-sm md:text-base">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <div className="relative overflow-hidden h-[420px] md:h-[560px] border border-white/10">
            <motion.img
              style={{ y }}
              src={ABOUT_IMG}
              alt="Qauntum International team"
              className="absolute inset-0 h-[120%] w-full object-cover"
            />
            <div className="absolute inset-0 bg-black/20" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
